import { useMemo } from "react";
import { localizedNumber } from "../../../utils/help/localization/localization";
import LoyaltyOffer from "../../../utils/LoyaltyOfferClass/LoyaltyOffer";
import { resolveOfferSum } from "../../../utils/loyalty/offerCopy";
import { sanitizeOfferHtml } from "../../../utils/loyalty/offerHtml";
import { useFixedOfferPricing } from "./useFixedOfferPricing";

/**
 * Offer copy ready to render as HTML: `{sum}` resolved, and sanitised by
 * {@link sanitizeOfferHtml} so interpolated item names cannot inject markup.
 *
 * The token is what a fixed bundle's items cost apart, which is exactly the
 * menu card's struck price — so both come from {@link useFixedOfferPricing},
 * and the copy can never quote a figure the card does not. Where there is no
 * such figure, {@link resolveOfferSum} takes the strikethrough away with it
 * rather than leaving a guest a literal `{sum}`.
 */
export const useOfferDescriptionHtml = (
  offer: LoyaltyOffer | undefined,
  text: string | undefined
): string => {
  const sum = useFixedOfferPricing(offer)?.priceBefore;

  return useMemo(
    () =>
      text
        ? sanitizeOfferHtml(resolveOfferSum(text, sum, localizedNumber))
        : "",
    [text, sum]
  );
};
